import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue';
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { useWorkspaceStore } from '@/rd/WorkspaceStore'
import { LoadMode } from '@/util/AsyncData'
import { workspaceTypeInfos } from '@/rd/ResearchDataModel'
import CompactItem from '@/util/CompactItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchGroupItem',
  props: {
  dataGroupId: String,
  small: Boolean,
  ensureLoaded: Boolean,
  selectMode: Boolean,
},
  setup(__props) {

const props = __props;



const workspaceStore = useWorkspaceStore()
const dataGroupStore = useDataGroupStore()
const userStore = useUserStore()

const loadModeRef = computed(() => props.ensureLoaded ? LoadMode.EnsureLoaded : LoadMode.TrackOnly)
const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(props.dataGroupId, loadModeRef.value)?.data)
const ownerRef = computed(() => userStore.getAsyncUser(workspaceRef.value?.ownerId, loadModeRef.value)?.data)
const workspaceRef = computed(() => workspaceStore.getAsyncWorkspacesForGroups([props.dataGroupId], loadModeRef.value).at(0)?.data)
const logoRef = computed(() => workspaceTypeInfos.find(t => t.id == (workspaceRef.value?.dataFileBaseType ?? 'TestData'))?.icon)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CompactItem, {
    class: "research-group-item",
    pageUrl: dataGroupRef.value?.pageUrl
  }, {
    icon: _withCtx(() => [
      _createElementVNode("img", { src: logoRef.value }, null, 8, _hoisted_1)
    ]),
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(dataGroupRef.value?.name), 1)
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode(_toDisplayString(workspaceRef.value?.workspaceTypeInfo?.description) + " managed by " + _toDisplayString(ownerRef.value?.displayName), 1)
    ]),
    _: 1
  }, 8, ["pageUrl"]))
}
}

})